
















import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import { endpoints } from "@/endpoints";
import RcaEndpointData from "./data-mixin";

@Component
export default class CompletenessBanner extends mixins(RcaEndpointData) {
    @Prop({ required: true }) startDate!: string;
    @Prop({ required: true }) endDate!: string;

    mounted() {
        this.fetch();
    }

    /** One key over both fetch inputs so a date-range change triggers exactly one fetch. Stacked
     * @Watch decorators fire once per changed prop, so changing the range (startDate + endDate in
     * the same tick) used to fetch twice. */
    private get fetchParamsKey(): string {
        return `${this.startDate}|${this.endDate}`;
    }

    @Watch("fetchParamsKey")
    onRangeChanged() {
        this.fetch();
    }

    fetch() {
        if (!this.startDate || !this.endDate) return;
        this.loadData(endpoints.roadClosureAnalyticsCompletenessFlagsUrl, {
            start_date: this.startDate,
            end_date: this.endDate,
        });
    }

    get hasIncompleteData(): boolean {
        return Array.isArray(this.data) && this.data.length > 0;
    }

    get flagCount(): number {
        return Array.isArray(this.data) ? this.data.length : 0;
    }
}
